import SublimeMedia from '@components/common/SublimeMedia/SublimeMedia'
import Container from '@components/ui/Container/Container'
import { FC, useRef } from 'react'
import { MediaPicker } from 'types/mediaPicker'
import { ModuleProps } from '..'
import styles from './TwoImages.module.scss'

type TwoImagesProps = {
  imageOne?: MediaPicker
  imageTwo?: MediaPicker
  reversed?: boolean
} & ModuleProps

const TwoImages: FC<TwoImagesProps> = ({
  imageOne,
  imageTwo,
  reversed,
  lcp,
}) => {
  const container = useRef<HTMLDivElement>(null)

  return (
    <Container>
      <div
        className={`${styles.container} ${reversed && styles.reversed}`}
        ref={container}
      >
        <div className={styles.innerContainer}>
          <div className={`${styles.box} ${styles.large}`}>
            <SublimeMedia
              mediaPicker={imageOne}
              aspectRatio={'4 / 5'}
              priority={lcp}
            />
          </div>
          <div className={styles.box}>
            <SublimeMedia
              mediaPicker={imageTwo}
              aspectRatio={'4 / 5'}
              priority={lcp}
            />
          </div>
        </div>
      </div>
    </Container>
  )
}

export default TwoImages
